import cacheLs from "../cacheLs"

export default {
  addClass (state, data) {
    state.selectedclass = { ...data }
    cacheLs.set_class(data)
  }
}
